import { useEffect, useState } from 'react'
import api from '../../services/api'
import { Table } from 'react-bootstrap'
import Paper from '@material-ui/core/Paper'
import Container from '@material-ui/core/Container'

import './styles.css'

import NavBar from '../../components/NavBar/NavBar.js'
import Corpobackup from '../../components/CorpoBackups/CorpoBKPSemana'

function MainDashboard() {
  const [body, setBody] = useState({
    atual: [],
    atual_1: [],
    atual_2: [],
    atual_3: [],
    atual_4: [],
  })

  useEffect(() => {
    ;(() => {
      api.get('/backup_teste').then((response) => {
        const respost = response.data.atual
        const respost_1 = response.data.atual_1
        const respost_2 = response.data.atual_2
        const respost_3 = response.data.atual_3
        const respost_4 = response.data.atual_4
        console.log(respost_4)
        setBody({
          atual: respost,
          atual_1: respost_1,
          atual_2: respost_2,
          atual_3: respost_3,
          atual_4: respost_4,
        })
      })
    })()
  }, [])
  const data1 = new Date().toLocaleDateString()
  const splidData = data1.split('/')
  let dia = splidData[0]
  let mes = splidData[1]
  let ano = splidData[2]
  return (
    <div>
      <NavBar />
      <div className="MainDashboardMain">
        <div className="main">
          <Container component={Paper}>
            <Table striped bordered hover variant="light" size="sm">
              <thead>
                <tr>
                  <td>Empresa</td>
                  <td>HOST</td>
                  <td>Backup</td>
                  <td>Field</td>
                  <td>Status</td>
                  <td>Data</td>
                </tr>
              </thead>
              {body.atual
                .sort((a, b) => a.name_empresa.localeCompare(b.name_empresa))
                .map((data, index) => {
                  const getDate01 = new Date(
                    body.started_at
                  ).toLocaleDateString()

                  return (
                    <Corpobackup
                      key={data.id}
                      data={data}
                      index={index}
                      atual={body.atual.sort((a, b) =>
                        a.name_empresa.localeCompare(b.name_empresa)
                      )}
                      atual1={body.atual_1.sort((a, b) =>
                        a.name_empresa.localeCompare(b.name_empresa)
                      )}
                      atual2={body.atual_2.sort((a, b) =>
                        a.name_empresa.localeCompare(b.name_empresa)
                      )}
                      atual3={body.atual_3.sort((a, b) =>
                        a.name_empresa.localeCompare(b.name_empresa)
                      )}
                      atual4={body.atual_4.sort((a, b) =>
                        a.name_empresa.localeCompare(b.name_empresa)
                      )}
                    />
                  )
                })}
              <br />
            </Table>
          </Container>
          <br />
        </div>
      </div>
    </div>
  )
}

export default MainDashboard
